import { render } from "./Editor.vue?vue&type=template&id=0e2923df&ts=true"
import script from "./Editor.vue?vue&type=script&lang=ts"
export * from "./Editor.vue?vue&type=script&lang=ts"

import "./Editor.vue?vue&type=style&index=0&id=0e2923df&lang=scss"

import exportComponent from "C:\\Projekty\\StaryEOD\\Ideo.Core.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__